import React, { useEffect, useMemo, useCallback } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import BubbleComponent from "./BubbleComponent";
import ConversationComponent from "./ConversationComponent";
import SendIcon from "@mui/icons-material/Send";
import { db } from "../firebase/config";

export default function CountdownComponent(props) {
  //var releaseDate = useCallback(new Date("2023-09-01T09:00:00-06:00"), []);
  const releaseDate = useMemo(() => new Date(props.date), [props.date]);
  // const [distance, setDistance] = React.useState(Number());
  const [counter, setCounter] = React.useState({
    days: Number(),
    hours: Number(),
    minutes: Number(),
    seconds: Number(),
  });

  // const calculateDistance = () => {
  //   let now = new Date().getTime();
  //   setDistance(releaseDate - now);
  // };

  const setValues = useCallback(async (distance) => {
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    setCounter({
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    });
  }, []);

  useEffect(() => {
    let now = new Date().getTime();
    let distance = releaseDate - now;
    let timer = null;
    if (distance < 0) {
      //RENDER VIDEO
    } else {
      timer = setInterval(() => {
        setValues(distance);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [releaseDate, setValues, counter]);

  return (
    <div>
      <div class="countdownClass" id="countContainer">
        <table>
          <tr>
            <th class="tableItemNumber" id="daysValue">
              {counter.days}
            </th>
            <th class="tableItemNumber" id="hoursValue">
              {counter.hours}
            </th>
            <th class="tableItemNumber" id="minutesValue">
              {counter.minutes}
            </th>
            <th class="tableItemNumber" id="secondsValue">
              {counter.seconds}
            </th>
          </tr>
          <tr>
            <th class="tableItem">Días</th>
            <th class="tableItem">Horas</th>
            <th class="tableItem">Minutos</th>
            <th class="tableItem">Segundos</th>
          </tr>
        </table>
      </div>
    </div>
  );
}
